import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'graphql',
};

export class MessageAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  getCommentsForFinding({ personId, findingId }) {
    const query = `
      query GetComments($findingId: ID!, $personId: ID) {
        getCommentsForFinding(findingId: $findingId, personId: $personId) {
          id
          body
          created
          objectId
          objectType
          sender
        }
      }
    `;
    const data = {
      personId,
      findingId,
    };
    return super.get({ query, data })
      .then(({ getCommentsForFinding: comments }) => ({ messages: comments }));
  }

  addCommentToFinding({ personId, findingId, body }) {
    const mutation = `
      mutation AddComments($findingId: ID!, $personId: ID, $body: String) {
        addCommentToFinding(findingId: $findingId, personId: $personId,
                            body: $body) {
          id
          created
          body
          objectId
          objectType
          sender
        }
      }
    `;
    const data = { personId, findingId, body };
    return super.get({ query: mutation, data })
      .then(({ addCommentToFinding: comment }) => ({ message: comment }));
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/MessageAPI.js